import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { OrganizationSettingsEmailDomainsViewTopBar } from "./TopBar"

export const organizationSettingsEmailDomainsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: OrganizationSettingsEmailDomainsViewTopBar,
}
